<template>
  <div class="bg-gray-200 pt-20 min-h-screen">
    <div class="max-w-3xl sm:mx-auto border p-8 bg-white rounded mx-3">
      <div class="text-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mx-auto h-16 w-16 text-gray-600">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>

        <h3 class="mt-2 text-2xl font-semibold text-black">Restricted Section</h3>
        <p class="mt-2 text-lg text-gray-700">I'm sorry, but the account you are currently logged into, <strong>{{ currentUser.email }}</strong>, does not have access to the <strong>{{ section }}</strong> section of the Admin Dashboard.</p>
        <p class="mt-4 text-lg text-gray-700">Please use the main navigation on the left to try accessing a different section of the Admin Dashboard.</p>

        <p class="mt-10 text-sm text-gray-700">If you believe this is an error, please contact your show administrator, <strong>{{ admin_email }}</strong>, to update your User Access Settings.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: String,
    admin_email: String
  },
  computed: {
    currentUser () {
      return this.$store.state.user
    }
  }
}
</script>

<style>

</style>
